import { createReducer, on } from '@ngrx/store'
import { ProjectDialogActions } from './action-types'

const initState: IProjectDialogState = {
    area: {
        scope: null,
        requested: false
    },
    concernedSubject: {
        contractRole: null,
        ico: null,
        lpisUserId: null,
        name: null,
        opsubId: null,
        rodneCislo: null
    },
    toDtsrcSubject: {
        name: null,
        opsubId: null,
        lpisUserId: null,
        jpv: false,
        requested: false
    },
    lv: {
        lv: null,
        requested: false
    },
    par: {}
}

export const projectDialogReducer = createReducer(
    initState,
    on(ProjectDialogActions.resetProjectLv, (state) => {
        return {...state, lv: {...initState.lv}}
    }),
    on(ProjectDialogActions.resetProjectArea, (state) => {
        return {...state, area: {...initState.area}}
    }),
    on(ProjectDialogActions.resetProjectPar, (state) => {
        return {...state, par: {...initState.par}}
    }),
    on(ProjectDialogActions.resetProjectConcernedSubject, (state) => {
        return {...state, concernedSubject: {...initState.concernedSubject}}
    }),
    on(ProjectDialogActions.resetProjectToDtsrcSubject, (state) => {
        return {...state, toDtsrcSubject: {...initState.toDtsrcSubject}}
    }),
    on(ProjectDialogActions.setProjectLv, (state, props) => {
        return {...state, lv: props.lv}
    }),
    on(ProjectDialogActions.setProjectArea, (state, props) => {
        return {...state, area: props.area}
    }),
    on(ProjectDialogActions.setProjectPar, (state, props) => {
        return {...state, par: props.par}
    }),
    on(ProjectDialogActions.setProjectConcernedSubject, (state, props) => {
        return {...state, concernedSubject: props.concernedSubject}
    }),
    on(ProjectDialogActions.setProjectToDtsrcSubject, (state, props) => {
        return {...state, toDtsrcSubject: props.toDtsrcSubject}
    }),
    on(ProjectDialogActions.setProjectConcernedSubjectProperty, (state, props) => {
        const copy = {...state.concernedSubject}

        copy[props.property] = props.value

        return {...state, concernedSubject: copy}
    }),
    on(ProjectDialogActions.setProjectToDtsrcSubjectProperty, (state, props) => {
        const copy = {...state.toDtsrcSubject}

        copy[props.property] = props.value

        return {...state, toDtsrcSubject: copy}
    }),
    on(ProjectDialogActions.setProjectLvProperty, (state, props) => {
        const copy = {...state.lv}

        copy[props.property] = props.value

        return {...state, lv: copy}
    }),
    on(ProjectDialogActions.setProjectAreaProperty, (state, props) => {
        const copy = {...state.area}

        copy[props.property] = props.value

        return {...state, area: copy}
    })
)

export interface IProjectDialogState {
    area: any;
    concernedSubject: any;
    toDtsrcSubject: any;
    lv: any;
    par: any;
}